import React from "react"
import PropTypes from "prop-types"
import { graphql } from "gatsby"
import Flower from "../components/svg/flower"
import Layout from "../components/layout/layout"
import SlidesCarousel from "../components/SlidesCarousel/carousel"
import "./feedback.scss"

const findTheImage = (relativePath, images) => images.find(element => element.node.relativePath === relativePath)

const Feedback = ({ data }) => {
  const feedbacksWithImages = data.feedbacks.edges.map(feedback => {
    const image = findTheImage(feedback.node.image, data.images.edges)
    const result = {}
    result.name = feedback.node.name
    result.surname = feedback.node.surname
    result.text = feedback.node.text
    image ? result.image = image.node : result.image = null
    return result
  })
  return (
    <Layout>
      <div className="feedback">
        <h1 className="feedback__headline"
        >Отзывы наших учеников</h1>
        <SlidesCarousel
          cards={feedbacksWithImages}
        />
        <Flower classNameSvg="feedback__bg-flower" />
      </div>
    </Layout>

  )
}
export const pageQuery = graphql`
  query Feedbacks {
  feedbacks: allFeedbacksJson {
    edges {
      node {
        image
        name
        surname
        text
      }
    }
  }
  images: allFile(filter: {relativePath: {regex: "/(cms)\/(feedbacks)\/.+/"}}) {
    edges {
      node {
        relativePath
        childImageSharp {
          gatsbyImageData(
           width: 120
           placeholder: BLURRED
          )
        }
      }
    }
  }
}


`
Feedback.propTypes = {
  data: PropTypes.shape({
    feedbacks: PropTypes.shape(
      {
        edges: PropTypes.array
      }
    ),
    images: PropTypes.shape(
      {
        edges: PropTypes.array
      }
    )
  }).isRequired
}
export default Feedback
